import { render } from "./ImageWrapper.vue?vue&type=template&id=2380c75e&ts=true"
import script from "./ImageWrapper.vue?vue&type=script&lang=ts"
export * from "./ImageWrapper.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__